import React, { useState, useEffect } from "react";
import { countries } from "../../../_constants/staticData";
import VideoIFrame from "./VideoPreview";

export const InstructorInfo = ({ formState, handleChange, trasnlate }) => {
  const [preview, setPreview] = useState(false);
  const [showPreviewButton, setShowPreviewButton] = useState(false);
  const [showClosePreview, setShowClosePreview] = useState(false);

  const handleIntroductionLinkChange = (e) => {
    handleChange(e);
    let regVimeo = /^(http\:\/\/|https\:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/;
    let regYouTube =
      /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    let result = e.target.value.includes("vimeo")
      ? regVimeo.test(e.target.value)
      : regYouTube.test(e.target.value);
    if (result) {
      setShowPreviewButton(true);
    } else {
      setShowPreviewButton(false);
      setShowClosePreview(false);
    }
    setPreview(false);
  };

  const handlePreview = () => {
    setPreview(true);
    setShowClosePreview(true);
  };

  const handleClose = () => {
    setPreview(false);
    setShowClosePreview(false);
  };

  return (
    <>
      {/* <div className="align-title social">
        <h3>
          MORE INFORMATION <span>(Optional) Visible on Public Profile</span>
        </h3>
      </div>
      <div className="flex-wrapper">
        <div className="flex-left">
          <input
            type="text"
            placeholder={trasnlate(
              "Languages i.e. English, German, and Japanese"
            )}
            name="languages"
            value={formState.languages || ""}
            onChange={handleChange}
          />
        </div>

        <div className="flex-right">
          <input
            type="text"
            placeholder={trasnlate("Youtube URL")}
            name="youtubeProfile"
            value={formState.youtubeProfile || ""}
            onChange={handleChange}
          />
        </div>
      </div> */}
      <Accordian title="ADD LOCATION">
        <div className="flex-wrapper">
          <div className="flex-left">
            <input
              type="text"
              placeholder={trasnlate("City/Town, State")}
              name="publicLocation"
              value={formState.publicLocation || ""}
              onChange={handleChange}
            />
          </div>

          <div className="flex-right">
            <div className="styled-select">
              <select name="publicLocationCountry" onChange={handleChange}>
                <option value="">Select Country</option>
                {countries.map((country, index) => (
                  <option
                    value={country.name}
                    selected={country.name === formState.publicLocationCountry}
                    key={index}
                  >
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </Accordian>
      <Accordian title="ADD TEXT INTRODUCTION">
        <div className="flex-wrapper">
          <textarea
            name="introduction"
            onChange={handleChange}
            value={formState.introduction}
          ></textarea>
        </div>
      </Accordian>
      <Accordian title="ADD YOUTUBE INTRODUCTION LINK">
        <div className="flex-wrapper">
          <input
            type="text"
            name="introductionLink"
            placeholder={trasnlate("Add Introduction Link")}
            onChange={handleIntroductionLinkChange}
            value={formState.introductionLink}
            className="youTubeLinkInput"
          ></input>
        </div>
        <div className="videoPreviewContainer">
          {showPreviewButton && (
            <button
              type="submit"
              className="btn-submit"
              onClick={handlePreview}
            >
              Preview
            </button>
          )}
          {showClosePreview && (
            <button
              type="submit"
              className="btn-submit btn-preview-close"
              onClick={handleClose}
            >
              Close
            </button>
          )}
          {preview && <VideoIFrame url={formState.introductionLink} />}
        </div>
      </Accordian>
      <Accordian title="ADD PROFESSIONAL QUALIFICATIONS">
        <div className="flex-wrapper">
          <textarea
            type="text"
            name="qualifications"
            placeholder={trasnlate("Add Professional Qualifications")}
            onChange={handleChange}
            value={formState.qualifications}
          ></textarea>
        </div>
      </Accordian>
      <Accordian title="ADD AWARDS, ACHIEVEMENTS, CERTIFICATIONS">
        <div className="flex-wrapper">
          <textarea
            type="text"
            name="certifications"
            placeholder={trasnlate("Add Awards, Achievements, certifications")}
            onChange={handleChange}
            value={formState.certifications}
          ></textarea>
        </div>
      </Accordian>
    </>
  );
};

const Accordian = ({ title, style, children }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="additional-info">
      <div className="plus" onClick={() => setIsActive((state) => !state)}>
        {title}
      </div>
      {isActive && children}
    </div>
  );
};
